import { render, staticRenderFns } from "./ChevronTop.vue?vue&type=template&id=20501f1e&"
import script from "./ChevronTop.vue?vue&type=script&lang=js&"
export * from "./ChevronTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src367672788/src/github.com/trainn-tech/trainn-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20501f1e')) {
      api.createRecord('20501f1e', component.options)
    } else {
      api.reload('20501f1e', component.options)
    }
    module.hot.accept("./ChevronTop.vue?vue&type=template&id=20501f1e&", function () {
      api.rerender('20501f1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/icons/ChevronTop.vue"
export default component.exports